<template>
  <div>
    <el-form ref="formRef" label-width="190px">
      <el-row style="margin-bottom: 20px">
        <el-col :span="24"><b>维度拆分(Dimension Segmentation)</b></el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="时间(Time Dimension)">
            <el-radio-group v-model="timeDimension" @change="handleChange">
              <el-radio v-for="it in chartDateList" :label="it.value" :key="it.value">{{ it.name }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="流量维度(Traffic Dimension)">
            <el-checkbox-group v-model="traffic" @change="handleChange">
              <el-checkbox v-for="it in trafficList" :label="it.value" :key="it.value">{{ it.name }}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="export">
      <qx-btn @click="handleExport">导出(Export)</qx-btn>
    </div>
    <qx-table v-if="configs.length !== 0" class="table" :data="list" v-bind="$attrs" v-on="$listeners">
      <el-table-column v-for="config in configs" :key="config.prop" v-bind="config"/>
    </qx-table>
    <BasePagination
        :total="total"
        :curPage.sync="curPage"
        :pageSize="50"
        :pageSizes="[50]"
        @action="doAction"
        @updateCurPage="updateCurPage"/>
  </div>
</template>

<script>
import QxTable from '@/components/common/qx-table.vue'
import BasePagination from '../BasePagination'
import QxBtn from "components/common/qx-btn.vue";

export default {
  components: {
    QxBtn,
    QxTable, BasePagination
  },
  props: {
    value: Object,
    list: Array,
    cols: Array,
    tableProps: Array,
    summary: Array,
    dimensionLength: Number,
    compare: Boolean,
    curPage: Number,
    total: Number
  },
  data: function () {
    return {
      chartDateList: [{
        value: 1,
        name: '日(Day)'
      }],
      trafficList: [{
        value: 'media_id',
        name: '媒体(Media)'
      }, {
        value: 'ad_zone_id',
        name: '广告位(Ad Slot)'
      }, {
        value: 'platform_id',
        name: '操作系统(OS)'
      }, {
        value: 'ad_resource_type',
        name: '广告位样式(Ad Slot Type)'
      }]
    }
  },
  computed: {
    timeDimension: {
      get() {
        const v = this.value?.timeDimension
        // 移除小时维度后，历史值(4)统一降级为按天(1)
        return v === 4 ? 1 : (v || 1)
      },
      set(val) {
        this.$emit('input', {...this.value, timeDimension: val})
      }
    },
    traffic: {
      get() {
        return this.value.traffic || []
      },
      set(val) {
        this.$emit('input', {...this.value, traffic: val})
      }
    },
    creative: {
      get() {
        return this.value.creative || []
      },
      set(val) {
        this.$emit('input', {...this.value, creative: val})
      }
    },
    configs: function () {
      if (!this.cols || this.cols.length === 0) {
        return [];
      }
      let res = [];
      let tableProps = this.tableProps || [];
      for (let config of tableProps) {
        let colName = config.prop;
        let cfg = {...config};
        if (this.cols.indexOf(colName) >= 0 || config.required) {
          res.push(cfg);
        }
      }
      return res;
    }
  },
  methods: {
    handleChange: function () {
      this.$emit('change')
    },
    updateCurPage: function (param) {
      this.$emit('updateCurPage', param)
    },
    handleExport: function () {
      this.$emit('export');
    },
    doAction: function (action) {
      // this.$emit('action', action);
    },
  }
}
</script>

<style scoped>
.table {
  margin-bottom: 20px;
}
.export {
  text-align: right;
  margin-bottom: 20px
}
</style>
